import { Vue } from "vue-property-decorator";
import OtEventList from "./OtEventList.vue";
import OtPikaday from "./OtPikaday.vue";
import OtEventInfo from "./OtEventInfo.vue";
import OtCalendar from "./OtCalendar.vue";
Vue.mixin({
    components: {
        OtPikaday: OtPikaday,
        OtCalendar: OtCalendar,
        OtEventInfo: OtEventInfo,
        OtEventList: OtEventList,
    }
});



//////////////////
// WEBPACK FOOTER
// ./app/ts/components/index.ts
// module id = 226
// module chunks = 0